import custStructureReportNoStrain from './custStructureReportNoStrain'
export default custStructureReportNoStrain
